module.exports = __webpack_public_path__ + "static/walk-2595ef4f15754a1e07bb9b3ce77d3a0e.jpg";